import React, { useEffect, useState, useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useToastMessage } from "../../../components/ToastMessage/ToastMessage";
import { Toaster } from "@fluentui/react-components";
import { FormLoader } from "../../../components/Loader/FormLoader";
import { TableListLoader } from "../../../components/Loader/TableListLoader";
import { configFm } from "../../../types";
import { AppDispatch, RootState } from "../../../redux/store";

import FormAreaWrapper from "../../../components/Common/FormAreaWrapper";
import TableListWrapper from "../../../components/Common/TableListWrapper";

import {
  clearActiveItem,
  clearList,
  getVulnerabilityDetailById,
  getVulnerabilityListItems,
} from "../../../redux/Client/vulnerability";
import VulnerabilityFormWrapper from "../VulnerabilityFormWrapper";
import NoDataFound from "../../../components/NoDataFound/noDataFound";
const FORM_CONTEXT = "VULNERABILITY";

function VulnerabilityDetailPage() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { clientId, selectedItemId, action } = useParams<{
    clientId: string;
    selectedItemId?: string;
    action?: string;
  }>();
  const API_BASE_PATH = `/clients/${clientId}/vulnerability`;
  const { showToast, toasterId } = useToastMessage();
  const { activeItem, listItems, loading, activeItemloading } = useSelector(
    (state: RootState) => state.vulnerability
  );
  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const [configForm, setConfigForm] = useState<configFm>();
  const [currentRecord, setCurrentRecord] = useState(1);

  useEffect(() => {
    if (listItems.length > 0 && selectedItemId) {
      dispatch(getVulnerabilityDetailById(selectedItemId));
    }
  }, [listItems, selectedItemId, dispatch]);

  useEffect(() => {
    if (formSettingsObj.data?.formConfig) {
      const configObj = formSettingsObj.data.formConfig.find(
        (item: any) => item.context === FORM_CONTEXT
      );
      setConfigForm(configObj);
    }
  }, [formSettingsObj.data]);

  return (
    <>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <div className="admin_container_flex">
        {(action === "add" || listItems.length > 0) && (
          <VulnerabilityFormWrapper
            activeCustomerId={clientId}
            mode={action}
            dataList={listItems}
            context={FORM_CONTEXT}
            notify={showToast}
            section="vulnerability"
            apiPath={API_BASE_PATH}
            selectedRowItem={activeItem}
            activeRow={currentRecord}
            module="client"
          />
        )}

        {loading ? (
          <TableListLoader rows={8} columns={6} />
        ) : (
          listItems.length > 0 && (
            <TableListWrapper
              data={listItems}
              context={FORM_CONTEXT}
              selectedRowItem={activeItem}
              onRowAction={(action, row) =>
                navigate(
                  `${API_BASE_PATH}/${row?.vulnerability_id}/${
                    action || "view"
                  }`
                )
              }
              currentRecord={(index) => setCurrentRecord(index)}
            />
          )
        )}
      </div>
    </>
  );
}

export default VulnerabilityDetailPage;
